import {ReactComponent as DeviceReadngicon} from '../../assets/img/device-reading icon .svg'
import {ReactComponent as ActionPaln} from '../../assets/img/actionplan.svg'
import {ReactComponent as Ambulence} from '../../assets/img/ambulence.svg'
import { createClinicalAlertsApi } from '../../api-helpers/PatientApiHelper';
import { useEffect, useState } from 'react';
import { GetUserClinicalAlerts } from 'patients-experience-client';
import Spinner from '../../components/Spinner';
import { UserContextHolder } from '../../auth/UserContextHolder';
import { formatDateTime } from '../../helper/dateFormatter';
import { Link } from 'react-router-dom';

export const ClinicalAlert = () => {
    const ClinicalAlertsApi = createClinicalAlertsApi();
    const [loading, setLoading] = useState(false);
    const [clinicalAlerts, setClinicalAlerts] = useState<GetUserClinicalAlerts[]>([]);
    const [coachId, setCoachId] = useState<string>();

    const getClinicalAlerts = async () => {
        setLoading(true);
        try {
            const response = await ClinicalAlertsApi.clinicalAlertsControllerGetUserClinicalAlerts(coachId!);
            setClinicalAlerts(response.data);
        } catch (error) {
            console.error("Error fetching Clinical Alerts: ", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        UserContextHolder.addListener(() => {
            setCoachId(UserContextHolder.getUser()!.id);
        });
    }, []);

    useEffect(() => {
        if (coachId) {
            getClinicalAlerts();
        }
    }, [coachId]);
    
    return <div className='d-flex flex-column h-100'>
            <div className="sidebar__content bg-blue-5 py-3 rounded-top">
                <div className='d-flex'> 
                    <div className='flex-fill'><h3 className="text-primary fs-20 m-0">Clinical Alert </h3></div>
                    <div className='ps-4'>
                        <Link to="/clinical-alerts"className="a-link a-underline text-info fs-12 text-nowrap">View all
                        </Link>
                    </div>
                </div>
                <span className="d-block fs-11 text-light">Urgent and emergent patient alerts requiring immediate attention</span>
            </div>
            <div className="sidebar__content bg-blue-5 py-3 flex-grow-1 p-3 h-lg-100 min_height_30">
                <div className=" sidebar__content-scroll bg-white rounded-top p-0 h-100">
                    {!clinicalAlerts.length && loading && <Spinner />}
                    {
                        clinicalAlerts.length && !loading ?
                            clinicalAlerts.map((alert: GetUserClinicalAlerts) => <>
                                <div className="d-flex p-3">
                                    <div className="text-center">
                                        <a href="#" className="d-flex justify-content-center border-yellow text-center text-white">
                                            <i className="material-symbols-outlined m-auto">
                                                { 
                                                    alert.episodeType.name.toLowerCase().includes('emergent') ? 
                                                        <Ambulence /> 
                                                        : alert.episodeType.name.toLowerCase().includes('urgent') && !alert.episodeType.name.toLowerCase().includes('non') ? <DeviceReadngicon /> 
                                                        : alert.episodeType.name.toLowerCase().includes('non') && alert.episodeType.name.toLowerCase().includes('urgent') ? <ActionPaln /> : '' }
                                            </i>
                                        </a>
                                        <div className="fs-10 text-primary text-center mt-1">{alert.episodeType.name}</div>
                                    </div>
                                    <div className="flex-fill ps-3">
                                        <div className="d-flex pt-1">
                                            <div className="flex-fill lh-sm">
                                                <a className="fw-bold" href="#">{alert.eventType.name}</a>
                                                <div className="fs-12 text-light mt-1">
                                                    Patient: <a className="a-link text-light" href="#">{alert.patient.name}</a>
                                                </div>
                                            </div>
                                            <div className="ps-4">
                                                <span className="d-block fs-11 text-light">{formatDateTime(alert.createdAt)}</span>
                                            </div>
                                        </div>
                                        <div className="text-end">
                                            <Link to={`/patients/${alert.patient.id}/clinical-alerts`} className="a-link a-underline text-info fs-12 text-nowrap">View</Link>
                                        </div>
                                    </div>
                                </div>
                                <hr className="m-0" />
                            </>) : ''
                    }
                </div>
            </div>
    </div>
}